import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingLayout } from './LoadingLayout';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const [showLoading, setShowLoading] = useState(false);
  const location = useLocation();
  
  // Check if we have cached data for this route
  const hasCachedData = () => {
    const path = location.pathname;
    if (path.includes('/show/')) {
      const showId = path.split('/').pop();
      return !!sessionStorage.getItem(`show_${showId}`);
    }
    if (path === '/popular') {
      return !!sessionStorage.getItem('popularShows');
    }
    return false;
  };

  useEffect(() => {
    if (loading && !hasCachedData()) {
      const timer = setTimeout(() => {
        setShowLoading(true);
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setShowLoading(false);
    }
  }, [loading, location.pathname]);

  // Don't show loading if we have cached data
  if ((showLoading || loading) && !user && !hasCachedData()) {
    return <LoadingLayout />;
  }
  
  if (!user) {
    const fullReturnUrl = window.location.href;
    localStorage.setItem('returnTo', fullReturnUrl);
    return <Navigate to="/login" replace />;
  }

  return children;
} 